<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Cm63Q6/tc-custom/9781429994798.jpg?1737765199513" alt="This image is the cover for the book Finding Jack"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Finding Jack
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>When the war ends, how do you leave your best friend behind? <br/><br/></i></b>After losing his young family in a tragic accident, Fletcher Carson joins the flagging war effort in Vietnam. Deeply depressed, he plans to die in the war. But during one of his early missions, Fletcher rescues a critically wounded yellow Lab whom he nurses back to health and names Jack. As Fletcher and Jack patrol and survive the forests of Vietnam, Fletcher slowly regains the will to live. <br/><br/>At the end of the war, the U.S. Government announces that due to the cost of withdrawal, all U.S. dogs serving in the war have been declared "surplus military equipment" and will not be transported home. For the hundreds of dog handlers throughout Vietnam, whose dogs had saved countless lives, the news is greeted with shock and disbelief. For Fletcher, he knows that if he abandons Jack, then he too will be lost. Ordered to leave Jack behind, he refuses—and so begins their journey. <br/><br/>Based on the actual existence and abandonment of canine units in Vietnam, Gareth Crocker's <i>Finding Jack </i>is a novel of friendship and love under desperate circumstances that will grab your heart and won't let go.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gareth Crocker
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3e3e2610